// eslint-disable import/prefer-default-export
export const FADING_STRATEGIES = {
  MTL: 'MTL',
  MTL_S: 'MTL-S',
};

export const OUTCOME_MEASUREMENT_TYPES = {
  BINARY: 'binary',
  WEIGHTED: 'weighted',
  RATING_SCALE: 'rating_scale',
};
